import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import { Assign } from "../../../../components/svg/svgImageList";
import { AssignJobToUser as PermissionAssignJobToUser } from "../../../../services/authorization/Permissions";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { AssignJobToUserProps } from "./AssignJobToUserProps";
import { AssignJobToUserButtonModal } from "../Dialogs";

export const AssignJobToUserButton = observer(function (props: AssignJobToUserProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();
  const { userFromProjectId: projectId, jobsStorage } = { ...props };

  const isDisabled = useCallback(
    () =>
      !permissionsService.userHasPermissionTo(PermissionAssignJobToUser) ||
      !jobsStorage.anyItemsSelected,
    [jobsStorage.anyItemsSelected]
  );

  return (
    <>
      <Button
        icon={{
          svg: Assign,
          textKey: "jobs.AssignJobToUserButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-assign"]),
        }}
        disabled={isDisabled()}
        onClick={toggleModal}
      />
      <AssignJobToUserButtonModal
        isVisible={isVisible}
        toggleModal={toggleModal}
        userFromProjectId={projectId}
        jobsStorage={jobsStorage}
      />
    </>
  );
});
